import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DbnpRegistriesBasicInfoComponent from './dbnp-registries-basic-info.component';
import DbnpRegistriesGSTInfoComponent from './dbnp-registries-gst-info.component';
import DbnpRegistriesPanInfoComponent from './dbnp-registries-pan-info.component';
import DbnpRegistriesKeypairInfoComponent from './dbnp-registries-keypair-info.component';

function DbnpRegistriesComponent ({ 
  id, handleBacicInnerFormChange, handleInnerFormChange, dbnpname, opsnumber, subDomains, domains, countries, back, handleFormSubmit, selectedDbnpRegistry 
}: any) {
    const tabItems=[
        {
            id:1,
            title:'DBNP Registry',
            component: <DbnpRegistriesBasicInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
            dbnpname={dbnpname}
            opsnumber={opsnumber}
            subDomains={subDomains}
            domains={domains}
            countries={countries}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'GST',
            component: <DbnpRegistriesGSTInfoComponent 
            handleInnerFormChange={handleInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
            isVisible:true,
        },
        {
            id:3,
            title:'PAN',
            component: <DbnpRegistriesPanInfoComponent
            handleInnerFormChange={handleInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
        />,
        isVisible:true,
        },
        {
            id:4,
            title:'KeyPair',
            component: <DbnpRegistriesKeypairInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbnpRegistry={selectedDbnpRegistry}
           />,
           isVisible:id > 0 ? true : false,
        }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
   
     </div>
  );
}
export default DbnpRegistriesComponent;
